module.exports = __webpack_public_path__ + "@/assets/img/tneprocedure.6d22c647.png";